import { FormattedMessage } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';
import CROSS_PATH_STRINGS from './crossPaths.strings';

const aboutFooterHero = require('../../../../assets/images/about/about-footer-hero.jpg');
const aboutFooterHeroAvif = require('../../../../assets/images/about/about-footer-hero.avif');
const aboutFooterHeroWebp = require('../../../../assets/images/about/about-footer-hero.webp');
const aboutFooterHeroMobile = require('../../../../assets/images/about/about-footer-hero-750w.jpg');
const aboutFooterHeroMobileAvif = require('../../../../assets/images/about/about-footer-hero-750w.avif');
const aboutFooterHeroMobileWebp = require('../../../../assets/images/about/about-footer-hero-750w.webp');

const CrossPaths = (): JSX.Element => {
  const {
    formattedDefaultMessages: { RUNNER_IMAGE_ALT, JOIN_OUR_TEAM, GET_PRESS_DETAILS }
  } = useFormatMessage(CROSS_PATH_STRINGS);

  return (
    <div className={styles.container}>
      <picture>
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={aboutFooterHeroMobile} type="image/jpg" />
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={aboutFooterHeroMobileAvif} type="image/avif" />
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={aboutFooterHeroMobileWebp} type="image/webp" />
        <source srcSet={aboutFooterHeroAvif} type="image/avif" />
        <source srcSet={aboutFooterHeroWebp} type="image/webp" />
        <img src={aboutFooterHero} alt={RUNNER_IMAGE_ALT} className={styles.heroImage} loading="lazy" />
      </picture>
      <div className={styles.contentContainer}>
        <div className={styles.title}>
          <FormattedMessage defaultMessage="Let’s cross paths" />
        </div>
        <div className={styles.subtitle}>
          <FormattedMessage defaultMessage="Ready to take the next step in your career journey? Want to partner up for a story? We look forward to connecting with you." />
        </div>
        <div className={styles.ctaContainer}>
          <Button
            text={JOIN_OUR_TEAM}
            linkInfo={{ href: '/careers' }}
            className={styles.ctaButton}
            onClick={() => {
              /* do nothing - href redirects */
            }}
            testId="about-join-our-team"
            variant="primary"
          />
          <Button
            text={GET_PRESS_DETAILS}
            linkInfo={{ href: '/press' }}
            className={styles.ctaButton}
            testId="about-get-press-details"
            variant="default"
          />
        </div>
      </div>
    </div>
  );
};

export default CrossPaths;
